import {Injectable, signal} from '@angular/core';
import {AppError} from '../model/app-error';

@Injectable({
  providedIn: 'root',
})
export class AlertService {

  private alertSignal = signal<AppError | null>(null);
  private timeoutId: ReturnType<typeof setTimeout> | undefined;

  public get alert() {
    return this.alertSignal.asReadonly();
  }

  public showError(message: string): void {
    this.setAlert({message, type: 'error'});
  }

  public showSuccess(message: string): void {
    this.setAlert({message, type: 'success'});
  }

  public showInfo(message: string): void {
    this.setAlert({message, type: 'info'});
  }

  public showWarning(message: string): void {
    this.setAlert({message, type: 'warning'});
  }

  public clear(): void {
    this.alertSignal.set(null);
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }
  }

  private setAlert(error: AppError): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }
    this.alertSignal.set(error);
    this.timeoutId = setTimeout(() => {
      this.clear();
    }, 5000);
  }
}
